module.exports = __webpack_public_path__ + "media/semantic/dist/themes/default/assets/fonts/outline-icons-db78b9359171f24936b16d84f63af378.ttf";